import React from 'react'
import { HiOutlineDocumentText, HiOutlineDownload, HiOutlineMail, HiOutlineShieldCheck } from 'react-icons/hi'

const InfoPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 space-y-12">
      <header className="space-y-4 text-center">
        <h1 className="text-3xl sm:text-4xl font-bold text-white">Project Overview & Report</h1>
        <p className="text-base sm:text-lg text-gray-400">
          Learn more about the Fanalyzes.com - Football Sentiment Tracker project, download the latest report, and get in touch.
        </p>
      </header>

      <section className="bg-gray-900 border border-gray-800 rounded-xl p-6 sm:p-8 space-y-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 p-3 rounded-lg bg-orange-900/40 text-orange-400">
            <HiOutlineDocumentText className="h-6 w-6" />
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-white">Fanalyzes Beta v0.1 Report</h2>
          </div>
        </div>

        <a
          href="fanalyzesv0_1.pdf"
          download
          className="btn-primary inline-flex items-center gap-2"
        >
          <HiOutlineDownload className="h-5 w-5" />
          Download Latest Report (PDF)
        </a>
      </section>

      <section className="bg-gray-900 border border-gray-800 rounded-xl p-6 sm:p-8 space-y-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 p-3 rounded-lg bg-orange-900/40 text-orange-400">
            <HiOutlineMail className="h-6 w-6" />
          </div>
          <div className="space-y-3">
            <h2 className="text-2xl font-semibold text-white">Contact</h2>
            <p className="text-gray-400 leading-relaxed">
            Fanalyzes.com is in active, early-stage development. Feedback, bug reports, and suggestions are highly encouraged and greatly appreciated. 

            If you notice any mistakes, have ideas for new features, or wish to discuss the project's methodology, please do not hesitate to reach out.
            </p>
            <div className="space-y-2 text-gray-300">
              <p>Email: <a className="text-orange-400 hover:text-orange-300" href="mailto:guisecca17@gmail.com">guisecca17@gmail.com</a></p>
              <p>LinkedIn: <a className="text-orange-400 hover:text-orange-300" href="https://www.linkedin.com/in/guilherme-secca-6b18242b1/" target="_blank" rel="noreferrer">Guilherme Secca</a></p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-900 border border-gray-800 rounded-xl p-6 sm:p-8 space-y-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 p-3 rounded-lg bg-orange-900/40 text-orange-400">
            <HiOutlineShieldCheck className="h-6 w-6" />
          </div>
          <div className="space-y-3">
            <h2 className="text-2xl font-semibold text-white">Usage & Disclaimer</h2>
            <ul className="space-y-3 text-gray-400 leading-relaxed list-disc list-inside">
              <li>
                The Football Sentiment Tracker is provided for informational purposes only. It should not be
                used as financial, betting, or investment advice.
              </li>
              <li>
                Sentiment scores are generated from public user-generated content and may contain biases,
                inaccuracies, or incomplete narratives.
              </li>
              <li>
                Redistribution of the report is permitted with attribution. Commercial use requires prior written consent.
              </li>
              <li>
                By downloading the report, you acknowledge that any decisions made based on this analysis are your
                responsibility.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  )
}

export default InfoPage

